import { render } from "./discussion.vue?vue&type=template&id=2c8e96c9"
import script from "./discussion.vue?vue&type=script&lang=js"
export * from "./discussion.vue?vue&type=script&lang=js"

import "./discussion.vue?vue&type=style&index=0&id=2c8e96c9&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__